var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileVideoOn = function SvgMobileVideoOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23 7-7 5 7 5Z",
    "data-name": "Path 1072"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    "data-name": "Rectangle 43",
    rx: 2,
    transform: "translate(1 5)"
  }))));
};
export default SvgMobileVideoOn;